import React, { useEffect, useState } from "react";
import { boardFetch, isDemoData } from "../boardData";
import { DEMO_WEATHER_ICON } from "../demo/demoContent";
import { OWM_API_KEY, useCoordinates, WidgetShell, EmptyState } from "./common";

// Current conditions + short forecast from OpenWeatherMap.
const CurrentWeatherWidget = ({ config = {}, agency, board }) => {
  const { lat, lng } = useCoordinates(agency, board);
  const [data, setData] = useState(null);
  const units = config.units === "metric" ? "metric" : "imperial";
  const unitSym = units === "metric" ? "°C" : "°F";

  useEffect(() => {
    if (lat == null || lng == null) return undefined;
    let cancelled = false;
    const load = async () => {
      try {
        const res = await boardFetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&units=${units}&appid=${OWM_API_KEY}`
        );
        const json = await res.json();
        if (!cancelled) setData(json);
      } catch (err) {
        console.warn("weather fetch failed", err);
      }
    };
    load();
    const t = setInterval(load, 60 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [lat, lng, units]);

  if (lat == null || lng == null) {
    return (
      <WidgetShell title="Weather">
        <EmptyState icon="☁" label="Set this board's location to show weather." />
      </WidgetShell>
    );
  }
  if (!data || !data.main) {
    return (
      <WidgetShell title="Weather">
        <div className="sb-loading-text">Loading weather…</div>
      </WidgetShell>
    );
  }

  const w = data.weather?.[0];
  return (
    <WidgetShell title={data.name ? `Weather · ${data.name}` : "Weather"}>
      <div className="sb-weather">
        {w?.icon && (
          <img
            className="sb-weather-icon"
            src={isDemoData() ? DEMO_WEATHER_ICON : `https://openweathermap.org/img/wn/${w.icon}@2x.png`}
            alt={w?.description || "conditions"}
          />
        )}
        <div className="sb-weather-temp">
          {Math.round(data.main.temp)}
          {unitSym}
        </div>
        <div className="sb-weather-meta">
          <div className="sb-weather-desc">{w?.description}</div>
          <div>Feels {Math.round(data.main.feels_like)}{unitSym}</div>
          <div>Humidity {data.main.humidity}%</div>
        </div>
      </div>
    </WidgetShell>
  );
};

export default CurrentWeatherWidget;
